import { Loader } from '@googlemaps/js-api-loader';

const loader = new Loader({
  apiKey: window.themeData.googleMapsApiKey,  // set this in .env
  version: 'weekly',
  libraries: ['places'],                             // add more if needed
});

loader.load().then(() => {
  initMap();   // Google JS API is guaranteed to be on window.google here
});

function initMap() {
  const mapElement = document.getElementById('map');
  if (!mapElement) return;

  const iconBase = themeData.iconBase;
  
  // Utilize a separate function for map styling
  const mapStyles = [
    { featureType: 'administrative', elementType: 'labels.text.fill', stylers: [{ color: '#444444' }] },
    { featureType: 'landscape', elementType: 'all', stylers: [{ color: '#f6f6f2' }] },
    { featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'off' }] },
    { featureType: 'road', elementType: 'all', stylers: [{ saturation: -100 }, { lightness: 45 }] },
    { featureType: 'road.highway', elementType: 'all', stylers: [{ visibility: 'simplified' }] },
    { featureType: 'road.arterial', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    { featureType: 'transit', elementType: 'all', stylers: [{ visibility: 'off' }] },
    { featureType: 'water', elementType: 'all', stylers: [{ color: '#e8e8e4' }, { visibility: 'on' }] }
  ];  

  let map;
  const mapOptions = {
    zoom: 15,
    styles: mapStyles,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    zoomControl: true,
    streetViewControl: false,
    scrollwheel: false,
    draggable: true,
    mapTypeControl: false 
  };

  const lat = parseFloat(mapElement.dataset.lat);
  const lng = parseFloat(mapElement.dataset.lng);
  if (!lat || !lng) return;

  mapOptions.center = { lat, lng };
  map = new google.maps.Map(mapElement, mapOptions);

  new google.maps.Marker({
    map,
    position: { lat, lng },
  });
}